module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv6-06e569a2b9cdb1eb41af1e461a414967.jpg";